export const comma = function(text, maximumFractionDigits){
    if(text===null || text === undefined) return "";
    return text.toLocaleString(undefined, { maximumFractionDigits: maximumFractionDigits });   
}